// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3SpfV","title":"styles_title__1-3Bq"};